import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BrandActions } from "@youm-front/brand/data-access";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { RoomBrandActions } from "../actions";
import {
  RoomBrandCreateRequestDTO,
  RoomBrandDeleteRequestDTO,
  RoomBrandUpdateRequestDTO,
  RoomBrandUseRequestDTO
} from "../dto";
import { RoomBrandService } from "../services";

@Injectable()
export class RoomBrandEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomBrandService: RoomBrandService
  ) {}

  roomBrandCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandActions.roomBrandCreate),
      switchMap((_) =>
        this.roomBrandService
          .roomBrandCreate(
            new RoomBrandCreateRequestDTO({
              roomId: _.roomBrandCreateVO.value.roomId,
              brandTitle: _.roomBrandCreateVO.value.brandTitle
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandActions.roomBrandCreateSuccess({
                brand: _.data.brand
              }),
              BrandActions.brandCreateSuccess({
                brand: _.data.brand
              })
            ]),
            catchError((_: Error) => [
              RoomBrandActions.roomBrandCreateFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandActions.roomBrandDelete),
      switchMap((_) =>
        this.roomBrandService
          .roomBrandDelete(
            new RoomBrandDeleteRequestDTO({
              roomId: _.roomBrandDeleteVO.value.roomId,
              brandId: _.roomBrandDeleteVO.value.brandId
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandActions.roomBrandDeleteSuccess({
                brandId: _.roomBrandDeleteVO.value.brandId
              }),
              BrandActions.brandDeleteSuccess({
                brandId: _.roomBrandDeleteVO.value.brandId
              })
            ]),
            catchError((_: Error) => [
              RoomBrandActions.roomBrandDeleteFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandActions.roomBrandUpdate),
      switchMap((_) =>
        this.roomBrandService
          .roomBrandUpdate(
            new RoomBrandUpdateRequestDTO({
              roomId: _.roomBrandUpdateVO.value.roomId,
              brandId: _.roomBrandUpdateVO.value.brandUpdateVO.value.id,
              brandTitle: _.roomBrandUpdateVO.value.brandUpdateVO.value.title
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandActions.roomBrandUpdateSuccess({
                brand: _.data.brand
              }),
              BrandActions.brandUpdateSuccess({
                brand: _.data.brand
              })
            ]),
            catchError((_: Error) => [
              RoomBrandActions.roomBrandUpdateFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandActions.roomBrandUse),
      switchMap((_) =>
        this.roomBrandService
          .roomBrandUse(
            new RoomBrandUseRequestDTO({
              roomId: _.roomBrandUseVO.value.roomId,
              brandId: _.roomBrandUseVO.value.brandId
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandActions.roomBrandUseSuccess({
                roomBrandUseVO: _.roomBrandUseVO
              }),
              BrandActions.brandInUse({
                brandId: _.roomBrandUseVO.value.brandId
              })
            ]),
            catchError((_: Error) => [
              RoomBrandActions.roomBrandUseFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );
}
